import { render, staticRenderFns } from "./latestReserves.vue?vue&type=template&id=0f9e06f7&scoped=true"
import script from "./latestReserves.vue?vue&type=script&lang=js"
export * from "./latestReserves.vue?vue&type=script&lang=js"
import style0 from "./latestReserves.vue?vue&type=style&index=0&id=0f9e06f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9e06f7",
  null
  
)

export default component.exports